import axios from 'axios';

const saveUserAdminNotes = async (body: {
  userId: string;
  adminNotes: string;
}) => {
  await axios.post('/user_admin_notes', body);
};

export default saveUserAdminNotes;
